// Imports => React
import { useState, useEffect, useMemo } from 'react';
import { withStore } from '@stores';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';

// Imports => Constants
import {
  ICONS,
  KEYS,
  THEMES,
  TYPES,
  VARIANTS,
} from '@opp/ui-kit';
import { TITLES } from '@constants';

// Imports => Hooks
import { useFormActions } from '@hooks';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcRichContent,
  AcIcon,
  AcButton,
  AcTextInput,
  AcRatingInput,
} from '@opp/ui-kit';

const _CLASSES = {
  MAIN: 'ac-leave-feedback-modal ac-modal--size-sm',
  CONTENT: 'ac-leave-feedback-modal__content',
};

const AcLeaveFeedbackModal = ({ store: { ui }, submit, callback }) => {
  let raw_fields = {
    rating: 0,
    message: '',
  };
  let raw_errors = {
    rating: null,
    message: undefined,
  };

  const [fields, setFields] = useState(raw_fields);
  const [errors, setErrors] = useState(raw_errors);

  const { hasErrors, handleInputChange, handleInputValidation } =
        useFormActions({
          t,
          fields,
          setFields,
          errors,
          setErrors,
        });

  useEffect(() => {}, []);

  const handleClose = async (event) => {
    if (event && event.preventDefault) event.preventDefault();
    await ui.reset(KEYS.MODAL);
  };

  const handleSubmit = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.persist) event.persist();

    if (submit) {
      const data = fields;

      submit(data).then((response) => handleClose());
    }
  };

  const getContentClassNames = useMemo(() => {
    return clsx([_CLASSES.CONTENT]);
  }, []);

  const getStyleClassNames = useMemo(() => {
    return clsx([_CLASSES.MAIN]);
  }, []);

  const getRatingInputOptions = useMemo(() => {
    return {
      label: 'How satisfied are you with Online Payment Platform?',
      stars: 5,
      fractions: 1,
      value: fields.rating,
      type: TYPES.RATING,
      name: KEYS.RATING,
      callback: handleInputChange,
    };
  }, [fields, fields.rating]);

  const getFeedbackmessageInputOptions = useMemo(() => {
    return {
      label: 'Feedback',
      placeholder: 'Share your thought(s)',
      type: TYPES.TEXTAREA,
      name: KEYS.MESSAGE,
      value: fields.message,
      required: true,
      callback: handleInputChange,
      validation: handleInputValidation,
    };
  }, [fields, fields.message]);

  const getSubmitButtonOptions = useMemo(() => {
    return {
      type: TYPES.SUBMIT,
      theme: THEMES.OMEGA,
      disabled: hasErrors,
      title: 'Save',
      callback: handleSubmit,
    };
  }, [fields, errors, hasErrors]);

  const getCancelButtonOptions = useMemo(() => {
    return {
      type: TYPES.BUTTON,
      theme: THEMES.MEDIUM,
      variant: VARIANTS.TEXT,
      title: 'Cancel',
      callback: handleClose,
    };
  }, [fields]);

  return (
    <div className={getStyleClassNames}>
      <div className={getContentClassNames}>
        <AcContainer fluid>
          <AcRow>
            <AcColumn>
              <AcRatingInput {...getRatingInputOptions} />
            </AcColumn>
          </AcRow>

          <AcRow className={'h-margin-top-15'}>
            <AcColumn>
              <AcTextInput {...getFeedbackmessageInputOptions} />
            </AcColumn>
          </AcRow>

          <AcRow
            className={
              'h-text--align-center h-text--color-medium h-text--italic'
            }
          >
            <AcColumn>
              <AcRichContent
                content={
                  '<small>We use feedback to improve the experience and service of our products over time. If you have any immediate issues that need to be resolved, please open a support ticket.</small>'
                }
              />
            </AcColumn>
          </AcRow>

          <AcRow className={'h-margin-top-20'}>
            <AcColumn
              xxs={12}
              xs={7}
              sm={6}
              className={
                'h-text--align-left h-flex-v-align-center h-hidden-xxs h-hidden-xs h-hidden-sm'
              }
            >
              <AcButton {...getCancelButtonOptions}>
                <span>Cancel</span>
              </AcButton>
            </AcColumn>

            <AcColumn xxs={12} xs={5} sm={6} className={'h-text--align-right'}>
              <AcButton {...getSubmitButtonOptions}>
                <span>Send feedback</span>
              </AcButton>
            </AcColumn>
          </AcRow>
        </AcContainer>
      </div>
    </div>
  );
};

export default withStore(observer(AcLeaveFeedbackModal));
